import React from 'react';
import '../styles/Root.css';
import '../styles/nospartenaires.css';

// --- IMPORTS DES LOGOS ---
import armeeDeTerre from '../assets/nospartenaires/armeedeterre.png';
import saintRaphael from '../assets/nospartenaires/saintraphael.png';
import sid from '../assets/nospartenaires/sid.png';
import frejus from '../assets/nospartenaires/frejus.png';
import esterel from '../assets/nospartenaires/esterel.jpg';
import varDepartement from '../assets/nospartenaires/var.png';
import regionSud from '../assets/nospartenaires/regionsud.png';
import dci from '../assets/nospartenaires/dci.png';
import eda from '../assets/nospartenaires/eda.png';
import fnam from '../assets/nospartenaires/fnam.png';
import carac from '../assets/nospartenaires/carac.jpg';
import fondationDeFrance from '../assets/nospartenaires/fondationdefrance.jpg';
import franceMutualiste from '../assets/nospartenaires/francemutualiste.jpg';
import gueulesCassees from '../assets/nospartenaires/gueulescassees.png';
import mbda from '../assets/nospartenaires/mbda.png';
import ourry from '../assets/nospartenaires/ourry.PNG';
import monaco from '../assets/nospartenaires/monaco.jpg';
import prd from '../assets/nospartenaires/prd.png';
import emsome from '../assets/nospartenaires/emsome.png';
import sma from '../assets/nospartenaires/sma.png';
import anciensCombattants from '../assets/nospartenaires/ancienscombattants.jpg';
import rima2e from '../assets/nospartenaires/2erima.png'; 
import rima3e from '../assets/nospartenaires/3erima.jpg'; 
import ana21 from '../assets/nospartenaires/ana21.png';
import rmt from '../assets/nospartenaires/rmt.jpg';
import rpima1 from '../assets/nospartenaires/1erpima.png';
import rpima2 from '../assets/nospartenaires/2rpima.png';
import rpima3 from '../assets/nospartenaires/3rpima.png';
import rpima6 from '../assets/nospartenaires/6rpima.png';
import rpima8 from '../assets/nospartenaires/8rpima.png';
import rima1 from '../assets/nospartenaires/1ric.png';
import ricm from '../assets/nospartenaires/anaricm.png';
import rama1 from '../assets/nospartenaires/1rac.jpg';
import amicale3erac from '../assets/nospartenaires/amicale3erac.png';
import rama11 from '../assets/nospartenaires/11rama.png';
import museeinfanterie from '../assets/nospartenaires/museeinfanterie.jpg';
import museeartillerie from '../assets/nospartenaires/museeartillerie.jpg';
import dplv from '../assets/nospartenaires/dplv.jpg';
import anopex from '../assets/nospartenaires/anopex.png';
import aohca from '../assets/nospartenaires/aohca.jpg';
import unor from '../assets/nospartenaires/unor.jpg';
import symposium from '../assets/nospartenaires/symposium.jpg';
import souvenirFrancais from '../assets/nospartenaires/souvenirfrancais.png';
import shfr from '../assets/nospartenaires/shfr.png';
import leBivouac from '../assets/nospartenaires/lebivouac.jpg';
import laSabretache from '../assets/nospartenaires/sabretache.png';
import souvenirNapoleonien from '../assets/nospartenaires/souvenirnapoleonien.jpg';

const NosPartenaires = () => {
  const partenaires = [
    {
      id: 1,
      nom: "Armée de Terre",
      categorie: "Défense",
      description: "Force de souveraineté majeure, elle soutient le musée dans sa vocation d'éducation civique et de conservation de la mémoire combattante.",
      lien: "https://www.sengager.fr",
      logo: armeeDeTerre
    },
    {
      id: 2,
      nom: "Service d'Infrastructure de la Défense",
      categorie: "Défense",
      description: "Référent construction et maintenance des infrastructures militaires, le SID accompagne l'évolution structurelle du site.",
      lien: "https://www.youtube.com/@servicedinfrastructuredela9345",
      logo: sid
    },
    {
      id: 3,
      nom: "Ville de Fréjus",
      categorie: "Collectivités Territoriales",
      description: "Fréjus, ville d'accueil du musée et cité de garnison, est un partenaire historique du rayonnement de notre patrimoine.",
      lien: "https://www.ville-frejus.fr",
      logo: frejus
    },
    {
      id: 4,
      nom: "Ville de Saint-Raphaël",
      categorie: "Collectivités Territoriales",
      description: "Commune voisine engagée, elle participe activement à la promotion touristique et culturelle de l'établissement.",
      lien: "https://www.ville-saintraphael.fr",
      logo: saintRaphael
    },
    {
      id: 5,
      nom: "Esterel Côte d'Azur Agglomération",
      categorie: "Collectivités Territoriales",
      description: "Regroupant les communes du territoire, elle soutient les initiatives culturelles et l'attractivité de l'Est-Var.",
      lien: "https://esterelcotedazur-agglo.fr",
      logo: esterel
    },
    {
      id: 7,
      nom: "Département du Var",
      categorie: "Collectivités Territoriales",
      description: "Le Conseil départemental du Var accompagne les projets de valorisation du patrimoine militaire et historique local.",
      lien: "https://var.fr",
      logo: varDepartement
    },
    {
      id: 8,
      nom: "Région Sud - PACA",
      categorie: "Collectivités Territoriales",
      description: "La Région Provence-Alpes-Côte d'Azur soutient les grands projets de rénovation et le rayonnement inter-régional du musée.",
      lien: "https://www.maregionsud.fr",
      logo: regionSud
    },
    {
      id: 9,
      nom: "Défense Conseil International",
      categorie: "Mécène",
      description: "Opérateur de référence pour le transfert du savoir-faire du ministère des Armées à l'international.",
      lien: "https://groupedci.fr",
      logo: dci
    },
    {
      id: 10,
      nom: "Economat des Armées",
      categorie: "Mécène",
      description: "Établissement public de soutien logistique des forces en opérations et en métropole.",
      lien: "https://www.economat-armees.com",
      logo: eda
    },
    {
      id: 11,
      nom: "Fédération Nationale André Maginot",
      categorie: "Mécène",
      description: "Doyenne des associations du monde combattant, elle œuvre pour la mémoire et la solidarité entre générations.",
      lien: "https://www.federation-maginot.com",
      logo: fnam
    },
    {
      id: 12,
      nom: "Fondation Carac",
      categorie: "Mécène",
      description: "Fondation d'entreprise dédiée à la préservation du patrimoine mémoriel et au soutien du monde combattant.",
      lien: "https://www.carac.fr",
      logo: carac
    },
    {
      id: 13,
      nom: "Fondation de France",
      categorie: "Mécène",
      description: "Soutient des projets d'intérêt général et accompagne les actions mémorielles à fort impact social.",
      lien: "https://www.fondationdefrance.org/fr",
      logo: fondationDeFrance
    },
    {
      id: 14,
      nom: "France Mutualiste",
      categorie: "Mécène",
      description: "Mutuelle historique des militaires et anciens combattants, garante de la protection sociale de la communauté défense.",
      lien: "https://www.la-france-mutualiste.fr/",
      logo: franceMutualiste
    },
    {
      id: 15,
      nom: "Les Gueules Cassées",
      categorie: "Mécène",
      description: "Fondation centrée sur l'aide aux blessés de guerre et la transmission de l'histoire héroïque des combattants.",
      lien: "https://www.gueules-cassees.asso.fr",
      logo: gueulesCassees
    },
    {
      id: 16,
      nom: "MBDA",
      categorie: "Mécène",
      description: "Leader européen de la défense, MBDA soutient la conservation des traditions d'innovation technologique militaire.",
      lien: "https://www.mbda-systems.com/country-fr",
      logo: mbda
    },
    {
      id: 17,
      nom: "Ourry",
      categorie: "Mécène",
      description: "Groupe industriel partenaire engagé dans le mécénat culturel et la préservation de l'histoire nationale.",
      lien: "https://www.ourry.fr",
      logo: ourry
    },
    {
      id: 18,
      nom: "Monaco",
      categorie: "Mécène",
      description: "La Principauté de Monaco entretient des liens historiques profonds avec les Troupes de Marine.",
      lien: "https://www.gouv.mc",
      logo: monaco
    },
    {
      id: 19,
      nom: "PRD fondation",
      categorie: "Mécène",
      description: "Soutient les initiatives liées à la valorisation architecturale et à l'aménagement des espaces culturels.",
      lien: "https://www.prd-fr.com",
      logo: prd
    },
    {
      id: 20,
      nom: "EMSOME",
      categorie: "Troupes de marine",
      description: "École-mère des Troupes de Marine, elle assure la formation spécialisée Outre-mer et l'expertise culturelle.",
      lien: "https://www.terre.defense.gouv.fr/emsome",
      logo: emsome
    },
    {
      id: 21,
      nom: "Amicale du SMA",
      categorie: "Troupes de marine",
      description: "Le Service Militaire Adapté œuvre pour l'insertion sociale et professionnelle des jeunes en Outre-mer.",
      lien: "https://www.sma-amicales.fr",
      logo: sma
    },
    {
      id: 22,
      nom: "FNAOM-ACTDM",
      categorie: "Troupes de marine",
      description: "Fédération Nationale des Anciens d'Outre-mer et Anciens Combattants des Troupes de Marine.",
      lien: "https://www.troupesdemarine-ancredor.org",
      logo: anciensCombattants
    },
    {
      id: 23,
      nom: "Amicale du 2e RIMa",
      categorie: "Troupes de marine",
      description: "Fédère les anciens du 2e Régiment d'Infanterie de Marine et maintient les traditions du régiment de la Sarthe.",
      lien: "https://amicale2rima.fr",
      logo: rima2e
    },
    {
      id: 24,
      nom: "Amicale nationale du 3e RIMa",
      categorie: "Troupes de marine",
      description: "Association dédiée aux héritiers et anciens du 3e Régiment d'Infanterie de Marine basé à Vannes.",
      lien: "https://sites.google.com/site/amicaledu3rima",
      logo: rima3e
    },
    {
      id: 26,
      nom: "ANA 21e RIMa – 4e RIMa",
      categorie: "Troupes de marine",
      description: "Union des anciens de ces régiments historiques, piliers des forces de souveraineté.",
      lien: "https://www.facebook.com/groups/609603876317851",
      logo: ana21
    },
    {
      id: 27,
      nom: "Amicale du RMT",
      categorie: "Amicale",
      description: "Porte l'héritage prestigieux du Régiment de Marche du Tchad, unité de la 2e DB.",
      lien: "https://amicale-rmt.fr",
      logo: rmt
    },
    {
      id: 28,
      nom: "Association du 1er RPIMa",
      categorie: "Amicale",
      description: "Regroupe les anciens des forces spéciales héritiers des parachutistes de la France Libre (SAS).",
      lien: "https://www.quiosegagne.org",
      logo: rpima1
    },
    {
      id: 29,
      nom: "Amicale des anciens du 2e RPIMa",
      categorie: "Amicale",
      description: "Maintient les liens entre les anciens paras du 2e Régiment de Parachutistes d'Infanterie de Marine.",
      lien: "https://anciens2rpima.fr",
      logo: rpima2
    },
    {
      id: 30,
      nom: "Amicale du 3e RPIMa",
      categorie: "Amicale",
      description: "Héritière des traditions des parachutistes de Marine basés à Carcassonne.",
      lien: "https://www.amicale3rpima.fr",
      logo: rpima3
    },
    {
      id: 31,
      nom: "Amicale du 6e RPIMa",
      categorie: "Amicale",
      description: "Gardienne de la mémoire de l'illustre « Régiment de Bigeard ».",
      lien: "https://www.amicale-du-6rpima.fr",
      logo: rpima6
    },
    {
      id: 32,
      nom: "Amicale du 8e RPIMa",
      categorie: "Amicale",
      description: "Association des anciens du 8e Régiment de Parachutistes d'Infanterie de Marine de Castres.",
      lien: "https://www.amicaledu8etdu7.fr",
      logo: rpima8
    },
    {
      id: 33,
      nom: "Amicale du 1er RIMa",
      categorie: "Amicale",
      description: "Représente les anciens du plus ancien régiment des Troupes de Marine.",
      lien: "https://amicale.jeremyabelard.fr",
      logo: rima1
    },
    {
      id: 34,
      nom: "RICM",
      categorie: "Amicale",
      description: "Amicale du Régiment d'Infanterie Chars de Marine, unité la plus décorée de l'armée française.",
      lien: "https://www.anciens-du-ricm.org",
      logo: ricm
    },
    {
      id: 35,
      nom: "Amicale du 1er RAMa",
      categorie: "Amicale",
      description: "Fédère les anciens artilleurs de marine du 1er Régiment d'Artillerie de Marine.",
      lien: "https://www.1er-rama.org",
      logo: rama1
    },
    {
      id: 36,
      nom: "Amicale du 3e RAMa",
      categorie: "Amicale",
      description: "Regroupe les anciens de l'artillerie de marine du 3e RAMa.",
      lien: "#",
      logo: amicale3erac
    },
    {
      id: 37,
      nom: "Amicale du 11e RAMa",
      categorie: "Amicale",
      description: "Assure la cohésion des anciens artilleurs de marine de la 9e BIMa.",
      lien: "#",
      logo: rama11
    },
    {
      id: 38,
      nom: "Musée de l’Infanterie",
      categorie: "Association Partenaire Régionale",
      description: "Partenaire privilégié pour l'étude et la conservation des traditions de l'Infanterie française.",
      lien: "#",
      logo: museeinfanterie
    },
    {
      id: 39,
      nom: "Amis du Musée de l'Artillerie",
      categorie: "Association Partenaire Régionale",
      description: "Soutient les collections d'artillerie et collabore sur des projets mémoriels communs.",
      lien: "https://artillerie.asso.fr/amad/index.php",
      logo: museeartillerie
    },
    {
      id: 40,
      nom: "DPLV",
      categorie: "Association Partenaire Régionale",
      description: "Association Nationale des Membres de la Légion d’Honneur Décorés au Péril de Leur Vie.",
      lien: "#",
      logo: dplv
    },
    {
      id: 41,
      nom: "ANOPEX",
      categorie: "Association Partenaire Régionale",
      description: "Association Nationale des Combattants des Opérations Extérieures, pour la reconnaissance de la 4e génération du feu.",
      lien: "#",
      logo: anopex
    },
    {
      id: 42,
      nom: "AOHCA",
      categorie: "Association Partenaire Régionale",
      description: "Association regroupant les Officiers Honoraires de la zone Côte d’Azur.",
      lien: "#",
      logo: aohca
    },
    {
      id: 43,
      nom: "UNOR Cannes",
      categorie: "Association Partenaire Régionale",
      description: "Union Nationale des Officiers de Réserve de l'arrondissement de Cannes.",
      lien: "#",
      logo: unor
    },
    {
      id: 44,
      nom: "Symposium de la Mémoire",
      categorie: "Association Partenaire Régionale",
      description: "Association dédiée à la promotion du civisme et de la mémoire citoyenne auprès de la jeunesse.",
      lien: "#",
      logo: symposium
    },
    {
      id: 45,
      nom: "Souvenir Français",
      categorie: "Association Partenaire Régionale",
      description: "Association veillant à l'entretien des sépultures militaires et à la transmission du devoir de mémoire.",
      lien: "https://le-souvenir-francais.fr/",
      logo: souvenirFrancais
    },
    {
      id: 46,
      nom: "SHFR",
      categorie: "Association d'Histoire",
      description: "Société d’Histoire de Fréjus et de sa Région, experte du patrimoine local de l'Antiquité à nos jours.",
      lien: "https://www.shfr.fr",
      logo: shfr
    },
    {
      id: 47,
      nom: "Le Bivouac",
      categorie: "Association d'Histoire",
      description: "Amicale de passionnés dédiée à l'étude des uniformes, des traditions et du bivouac historique.",
      lien: "https://www.facebook.com/amicalelebivouac/?locale=fr_FR",
      logo: leBivouac
    },
    {
      id: 48,
      nom: "La Sabretache",
      categorie: "Association d'Histoire",
      description: "Société d'études d'histoire militaire reconnue pour ses publications et son expertise documentaire.",
      lien: "https://lasabretache.fr",
      logo: laSabretache
    },
    {
      id: 49,
      nom: "Souvenir Napoléonien",
      categorie: "Association d'Histoire",
      description: "La plus importante société d'histoire napoléonienne, veillant sur l'héritage de l'Empire.",
      lien: "http://www.souvenirnapoleonien.org",
      logo: souvenirNapoleonien
    }
  ];

  return (
    <>
      <section className="hero">
        <h1>Ses Partenaires</h1>
        <p>Ils soutiennent le Musée des Troupes de Marine dans ses missions de mémoire, de conservation et de rayonnement culturel.</p>
      </section>

      <main className="partenaires-container">
        <div className="partenaires-grid">
          {partenaires.map((partenaire) => (
            <article key={partenaire.id} className="partenaire-card">
              <div className="partenaire-logo">
                <img src={partenaire.logo} alt={`Logo ${partenaire.nom}`} loading="lazy" />
              </div>
              <div className="partenaire-info">
                <span className="partenaire-tag">{partenaire.categorie}</span>
                <h2>{partenaire.nom}</h2>
                <p>{partenaire.description}</p>
                
                {/* Condition : Affichage seulement si le lien n'est pas "#" */}
                {partenaire.lien !== "#" && (
                  <a 
                    href={partenaire.lien} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn-link"
                  >
                    Découvrir <i className="fas fa-external-link-alt"></i>
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </main>
    </>
  );
};

export default NosPartenaires;